export const TimeZonesOptions = [
  { value: "Hawaii", id: "Hawaii", title: "Hawaii (-10:00)" },
  { value: "Alaska", id: "Alaska", title: "Alaska (-09:00/-08:00)" },
  {
    value: "Pacific Time (US & Canada)",
    id: "Pacific Time (US & Canada)",
    title: "Pacific Time (US & Canada) (-08:00/-07:00)",
  },
  { value: "Arizona", id: "Arizona", title: "Arizona (-07:00)" },
  {
    value: "Mountain Time (US & Canada)",
    id: "Mountain Time (US & Canada)",
    title: "Mountain Time (US & Canada) (-07:00/-06:00)",
  },
  {
    value: "Central Time (US & Canada)",
    id: "Central Time (US & Canada)",
    title: "Central Time (US & Canada) (-06:00/-05:00)",
  },
  {
    value: "Eastern Time (US & Canada)",
    id: "Eastern Time (US & Canada)",
    title: "Eastern Time (US & Canada) (-05:00/-04:00)",
  },
  {
    value: "Indiana (East)",
    id: "Indiana (East)",
    title: "Indiana (East) (-05:00/-04:00)",
  },
  {
    value: "International Date Line West",
    id: "International Date Line West",
    title: "International Date Line West (-12:00)",
  },
  {
    value: "American Samoa",
    id: "American Samoa",
    title: "American Samoa (-11:00)",
  },
  {
    value: "Midway Island",
    id: "Midway Island",
    title: "Midway Island (-11:00)",
  },
  { value: "Tijuana", id: "Tijuana", title: "Tijuana (-08:00/-07:00)" },
  { value: "Chihuahua", id: "Chihuahua", title: "Chihuahua (-07:00/-06:00)" },
  { value: "Mazatlan", id: "Mazatlan", title: "Mazatlan (-07:00/-06:00)" },
  {
    value: "Central America",
    id: "Central America",
    title: "Central America (-06:00)",
  },
  {
    value: "Guadalajara",
    id: "Guadalajara",
    title: "Guadalajara (-06:00/-05:00)",
  },
  {
    value: "Mexico City",
    id: "Mexico City",
    title: "Mexico City (-06:00/-05:00)",
  },
  { value: "Monterrey", id: "Monterrey", title: "Monterrey (-06:00/-05:00)" },
  { value: "Saskatchewan", id: "Saskatchewan", title: "Saskatchewan (-06:00)" },
  { value: "Bogota", id: "Bogota", title: "Bogota (-05:00/-05:00)" },
  { value: "Eirunepe", id: "Eirunepe", title: "Eirunepe (-05:00/-05:00)" },
  { value: "Lima", id: "Lima", title: "Lima (-05:00/-05:00)" },
  { value: "Quito", id: "Quito", title: "Quito (-05:00/-05:00)" },
  { value: "Asuncion", id: "Asuncion", title: "Asuncion (-04:00/-03:00)" },
  {
    value: "Atlantic Time (Canada)",
    id: "Atlantic Time (Canada)",
    title: "Atlantic Time (Canada) (-04:00/-03:00)",
  },
  { value: "Caracas", id: "Caracas", title: "Caracas (-04:00/-04:00)" },
  { value: "Cuiaba", id: "Cuiaba", title: "Cuiaba (-04:00/-04:00)" },
  {
    value: "Georgetown",
    id: "Georgetown",
    title: "Georgetown (-04:00/-04:00)",
  },
  { value: "La Paz", id: "La Paz", title: "La Paz (-04:00/-04:00)" },
  { value: "Manaus", id: "Manaus", title: "Manaus (-04:00/-04:00)" },
  { value: "Puerto Rico", id: "Puerto Rico", title: "Puerto Rico (-04:00)" },
  { value: "Santiago", id: "Santiago", title: "Santiago (-04:00/-03:00)" },
  {
    value: "Newfoundland",
    id: "Newfoundland",
    title: "Newfoundland (-03:30/-02:30)",
  },
  { value: "Brasilia", id: "Brasilia", title: "Brasilia (-03:00/-03:00)" },
  {
    value: "Buenos Aires",
    id: "Buenos Aires",
    title: "Buenos Aires (-03:00/-03:00)",
  },
  { value: "Fortaleza", id: "Fortaleza", title: "Fortaleza (-03:00/-03:00)" },
  { value: "Greenland", id: "Greenland", title: "Greenland (-03:00/-02:00)" },
  {
    value: "Montevideo",
    id: "Montevideo",
    title: "Montevideo (-03:00/-03:00)",
  },
  {
    value: "Mid-Atlantic",
    id: "Mid-Atlantic",
    title: "Mid-Atlantic (-02:00/-02:00)",
  },
  { value: "Noronha", id: "Noronha", title: "Noronha (-02:00/-02:00)" },
  { value: "Azores", id: "Azores", title: "Azores (-01:00/+00:00)" },
  {
    value: "Cape Verde Is.",
    id: "Cape Verde Is.",
    title: "Cape Verde Is. (-01:00/-01:00)",
  },
  { value: "Edinburgh", id: "Edinburgh", title: "Edinburgh (+00:00/+01:00)" },
  { value: "Lisbon", id: "Lisbon", title: "Lisbon (+00:00/+01:00)" },
  { value: "London", id: "London", title: "London (+00:00/+01:00)" },
  { value: "Monrovia", id: "Monrovia", title: "Monrovia (+00:00)" },
  { value: "UTC", id: "UTC", title: "UTC (+00:00)" },
  { value: "Amsterdam", id: "Amsterdam", title: "Amsterdam (+01:00/+02:00)" },
  { value: "Belgrade", id: "Belgrade", title: "Belgrade (+01:00/+02:00)" },
  { value: "Berlin", id: "Berlin", title: "Berlin (+01:00/+02:00)" },
  { value: "Bern", id: "Bern", title: "Bern (+01:00/+02:00)" },
  {
    value: "Bratislava",
    id: "Bratislava",
    title: "Bratislava (+01:00/+02:00)",
  },
  { value: "Brussels", id: "Brussels", title: "Brussels (+01:00/+02:00)" },
  { value: "Budapest", id: "Budapest", title: "Budapest (+01:00/+02:00)" },
  {
    value: "Casablanca",
    id: "Casablanca",
    title: "Casablanca (+01:00/+00:00)",
  },
  {
    value: "Copenhagen",
    id: "Copenhagen",
    title: "Copenhagen (+01:00/+02:00)",
  },
  { value: "Dublin", id: "Dublin", title: "Dublin (+01:00/+00:00)" },
  { value: "Ljubljana", id: "Ljubljana", title: "Ljubljana (+01:00/+02:00)" },
  { value: "Madrid", id: "Madrid", title: "Madrid (+01:00/+02:00)" },
  { value: "Paris", id: "Paris", title: "Paris (+01:00/+02:00)" },
  { value: "Prague", id: "Prague", title: "Prague (+01:00/+02:00)" },
  { value: "Rome", id: "Rome", title: "Rome (+01:00/+02:00)" },
  { value: "Sarajevo", id: "Sarajevo", title: "Sarajevo (+01:00/+02:00)" },
  { value: "Skopje", id: "Skopje", title: "Skopje (+01:00/+02:00)" },
  { value: "Stockholm", id: "Stockholm", title: "Stockholm (+01:00/+02:00)" },
  { value: "Vienna", id: "Vienna", title: "Vienna (+01:00/+02:00)" },
  { value: "Warsaw", id: "Warsaw", title: "Warsaw (+01:00/+02:00)" },
  {
    value: "West Central Africa",
    id: "West Central Africa",
    title: "West Central Africa (+01:00)",
  },
  { value: "Zagreb", id: "Zagreb", title: "Zagreb (+01:00/+02:00)" },
  { value: "Zurich", id: "Zurich", title: "Zurich (+01:00/+02:00)" },
  { value: "Athens", id: "Athens", title: "Athens (+02:00/+03:00)" },
  { value: "Bucharest", id: "Bucharest", title: "Bucharest (+02:00/+03:00)" },
  { value: "Cairo", id: "Cairo", title: "Cairo (+02:00)" },
  { value: "Harare", id: "Harare", title: "Harare (+02:00)" },
  { value: "Helsinki", id: "Helsinki", title: "Helsinki (+02:00/+03:00)" },
  { value: "Jerusalem", id: "Jerusalem", title: "Jerusalem (+02:00/+03:00)" },
  { value: "Kaliningrad", id: "Kaliningrad", title: "Kaliningrad (+02:00)" },
  { value: "Kyiv", id: "Kyiv", title: "Kyiv (+02:00/+03:00)" },
  { value: "Pretoria", id: "Pretoria", title: "Pretoria (+02:00)" },
  { value: "Riga", id: "Riga", title: "Riga (+02:00/+03:00)" },
  { value: "Sofia", id: "Sofia", title: "Sofia (+02:00/+03:00)" },
  { value: "Tallinn", id: "Tallinn", title: "Tallinn (+02:00/+03:00)" },
  { value: "Vilnius", id: "Vilnius", title: "Vilnius (+02:00/+03:00)" },
  { value: "Baghdad", id: "Baghdad", title: "Baghdad (+03:00/+03:00)" },
  { value: "Istanbul", id: "Istanbul", title: "Istanbul (+03:00/+03:00)" },
  { value: "Kuwait", id: "Kuwait", title: "Kuwait (+03:00/+03:00)" },
  { value: "Minsk", id: "Minsk", title: "Minsk (+03:00/+03:00)" },
  { value: "Moscow", id: "Moscow", title: "Moscow (+03:00)" },
  { value: "Nairobi", id: "Nairobi", title: "Nairobi (+03:00)" },
  { value: "Riyadh", id: "Riyadh", title: "Riyadh (+03:00/+03:00)" },
  { value: "St. Petersburg", id: "St. Petersburg", title: "St. Petersburg (+03:00)" },
  { value: "Volgograd", id: "Volgograd", title: "Volgograd (+03:00/+03:00)" },
  { value: "Tehran", id: "Tehran", title: "Tehran (+03:30/+04:30)" },
  { value: "Abu Dhabi", id: "Abu Dhabi", title: "Abu Dhabi (+04:00/+04:00)" },
  { value: "Baku", id: "Baku", title: "Baku (+04:00/+04:00)" },
  { value: "Muscat", id: "Muscat", title: "Muscat (+04:00/+04:00)" },
  { value: "Samara", id: "Samara", title: "Samara (+04:00/+04:00)" },
  { value: "Tbilisi", id: "Tbilisi", title: "Tbilisi (+04:00/+04:00)" },
  { value: "Yerevan", id: "Yerevan", title: "Yerevan (+04:00/+04:00)" },
  { value: "Kabul", id: "Kabul", title: "Kabul (+04:30/+04:30)" },
  { value: "Ekaterinburg", id: "Ekaterinburg", title: "Ekaterinburg (+05:00/+05:00)" },
  { value: "Islamabad", id: "Islamabad", title: "Islamabad (+05:00)" },
  { value: "Karachi", id: "Karachi", title: "Karachi (+05:00)" },
  { value: "Tashkent", id: "Tashkent", title: "Tashkent (+05:00/+05:00)" },
  { value: "Chennai", id: "Chennai", title: "Chennai (+05:30)" },
  { value: "Kolkata", id: "Kolkata", title: "Kolkata (+05:30)" },
  { value: "Mumbai", id: "Mumbai", title: "Mumbai (+05:30)" },
  { value: "New Delhi", id: "New Delhi", title: "New Delhi (+05:30)" },
  {
    value: "Sri Jayawardenepura",
    id: 'Sri Jayawardenepura',
    title: "Sri Jayawardenepura (+05:30/+05:30)",
  },
  { value: "Kathmandu", id: "Kathmandu", title: "Kathmandu (+05:45/+05:45)" },
  { value: "Almaty", id: "Almaty", title: "Almaty (+06:00/+06:00)" },
  { value: "Astana", id: "Astana", title: "Astana (+06:00/+06:00)" },
  { value: "Dhaka", id: "Dhaka", title: "Dhaka (+06:00/+06:00)" },
  { value: "Urumqi", id: "Urumqi", title: "Urumqi (+06:00/+06:00)" },
  { value: "Rangoon", id: "Rangoon", title: "Rangoon (+06:30/+06:30)" },
  { value: "Bangkok", id: "Bangkok", title: "Bangkok (+07:00/+07:00)" },
  { value: "Hanoi", id: "Hanoi", title: "Hanoi (+07:00/+07:00)" },
  { value: "Jakarta", id: "Jakarta", title: "Jakarta (+07:00)" },
  { value: "Krasnoyarsk", id: "Krasnoyarsk", title: "Krasnoyarsk (+07:00/+07:00)" },
  { value: "Novosibirsk", id: "Novosibirsk", title: "Novosibirsk (+07:00/+07:00)" },
  { value: "Beijing", id: "Beijing", title: "Beijing (+08:00)" },
  { value: "Chongqing", id: "Chongqing", title: "Chongqing (+08:00)" },
  { value: "Hong Kong", id: "Hong Kong", title: "Hong Kong (+08:00)" },
  { value: "Irkutsk", id: "Irkutsk", title: "Irkutsk (+08:00/+08:00)" },
  { value: "Kuala Lumpur", id: "Kuala Lumpur", title: "Kuala Lumpur (+08:00/+08:00)" },
  { value: "Perth", id: "Perth", title: "Perth (+08:00)" },
  { value: "Philippines", id: "Philippines", title: "Philippines (+08:00)" },
  { value: "Singapore", id: "Singapore", title: "Singapore (+08:00/+08:00)" },
  { value: "Taipei", id: "Taipei", title: "Taipei (+08:00)" },
  { value: "Ulaanbaatar", id: "Ulaanbaatar", title: "Ulaanbaatar (+08:00/+08:00)" },
  { value: "Osaka", id: "Osaka", title: "Osaka (+09:00)" },
  { value: "Sapporo", id: "Sapporo", title: "Sapporo (+09:00)" },
  { value: "Seoul", id: "Seoul", title: "Seoul (+09:00)" },
  { value: "Tokyo", id: "Tokyo", title: "Tokyo (+09:00)" },
  { value: "Yakutsk", id: "Yakutsk", title: "Yakutsk (+09:00/+09:00)" },
  { value: "Adelaide", id: "Adelaide", title: "Adelaide (+09:30/+10:30)" },
  { value: "Darwin", id: "Darwin", title: "Darwin (+09:30)" },
  { value: "Brisbane", id: "Brisbane", title: "Brisbane (+10:00)" },
  { value: "Canberra", id: "Canberra", title: "Canberra (+10:00/+11:00)" },
  { value: "Guam", id: "Guam", title: "Guam (+10:00)" },
  { value: "Hobart", id: "Hobart", title: "Hobart (+10:00/+11:00)" },
  { value: "Melbourne", id: "Melbourne", title: "Melbourne (+10:00/+11:00)" },
  { value: "Port Moresby", id: "Port Moresby", title: "Port Moresby (+10:00/+10:00)" },
  { value: "Sydney", id: "Sydney", title: "Sydney (+10:00/+11:00)" },
  { value: "Vladivostok", id: "Vladivostok", title: "Vladivostok (+10:00/+10:00)" },
  { value: "Magadan", id: "Magadan", title: "Magadan (+11:00/+11:00)" },
  { value: "New Caledonia", id: "New Caledonia", title: "New Caledonia (+11:00/+11:00)" },
  { value: "Solomon Is.", id: "Solomon Is.", title: "Solomon Is. (+11:00/+11:00)" },
  { value: "Srednekolymsk", id: "Srednekolymsk", title: "Srednekolymsk (+11:00/+11:00)" },
  { value: "Auckland", id: "Auckland", title: "Auckland (+12:00/+13:00)" },
  { value: "Fiji", id: "Fiji", title: "Fiji (+12:00/+13:00)" },
  { value: "Kamchatka", id: "Kamchatka", title: "Kamchatka (+12:00/+12:00)" },
  { value: "Marshall Is.", id: "Marshall Is.", title: "Marshall Is. (+12:00/+12:00)" },
  { value: "Wellington", id: "Wellington", title: "Wellington (+12:00/+13:00)" },
  { value: "Chatham Is.", id: "Chatham Is.", title: "Chatham Is. (+12:45/+13:45)" },
  { value: "Nuku'alofa", id: "Nuku'alofa", title: "Nuku'alofa (+13:00/+13:00)" },
  { value: "Samoa", id: "Samoa", title: "Samoa (+13:00/+14:00)" },
  { value: "Tokelau Is.", id: "Tokelau Is.", title: "Tokelau Is. (+13:00/+13:00)" },
];
